import React from 'react';
import Breadcrumbs from '../../sections/Breadcrumbs';

const BuildPlatform: React.FC = () => (
  <div className="max-w-4xl mx-auto py-12 px-4">
    <Breadcrumbs items={[
      { label: 'Home', href: '/' },
      { label: 'Initiatives', href: '/initiatives/build-platform' },
      { label: 'Build Platform' }
    ]} />
    <h1 className="text-3xl font-bold mb-4">Build Platform</h1>
    <p>This is a placeholder for the Build Platform page.</p>
  </div>
);

export default BuildPlatform; 